import { cn } from '../../utils/cn';
import CustomIcon from '../customIcon/CustomIcon';

export const PAGE_HEADER_ALIGN_CLASS = {
    center: 'items-center text-center',
    start: 'items-start text-start',
} as const;

export const PAGE_HEADER_TITLE_CLASS =
    'font-semibold text-custom-gray-800 flex items-center gap-2 flex-nowrap';

export const PAGE_HEADER_TITLE_LG_CLASS = 'text-2xl !leading-relaxed';
export const PAGE_HEADER_TITLE_SM_CLASS = 'text-xl leading-7';
export const PAGE_HEADER_LEAD_CLASS = 'text-base !leading-relaxed text-custom-gray-800 mt-4';

type PageHeaderProps = {
    title: React.ReactNode;
    lead?: React.ReactNode;
    imgSrc?: string;
    imgAlt?: string;
    imgClassName?: string;
    className?: string;
    titleSize?: 'lg' | 'sm';
    align?: keyof typeof PAGE_HEADER_ALIGN_CLASS;
    children?: React.ReactNode | React.ReactNode[];
};

const PageHeader: React.FC<PageHeaderProps> = ({
    title,
    lead,
    imgSrc,
    imgClassName,
    imgAlt,
    className,
    titleSize = 'sm',
    align = 'center',
    children
}) => {
    return (
        <div
            className={cn(
                'flex flex-col',
                PAGE_HEADER_ALIGN_CLASS[align],
                className
            )}
        >
            {imgSrc ? (
                <CustomIcon
                    src={imgSrc}
                    alt={imgAlt}
                    className={cn('mb-4 md:mb-10', imgClassName)}
                />
            ) : null}
            <h1
                className={cn(
                    PAGE_HEADER_TITLE_CLASS,
                    titleSize === 'lg' ? PAGE_HEADER_TITLE_LG_CLASS : PAGE_HEADER_TITLE_SM_CLASS
                )}
            >
                {title}
            </h1>
            {lead ? <p className={PAGE_HEADER_LEAD_CLASS}>{lead}</p> : null}
            {children}
        </div>
    );
};

export default PageHeader;
